import React, { Component } from 'react';
import Link from 'gatsby-link';
import logoImg from '../static/svgs/logo.svg';
import Logo from './Logo';

const activeLinkStyle = {
  color: '#1E69B8',
};

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visibleMenu: false,
      visibleSubMenu: false,
    };

    this.handleVisableMenu = this.handleVisableMenu.bind(this);
    this.handleVisableSubMenu = this.handleVisableSubMenu.bind(this);
  }

  handleVisableMenu() {
    this.setState(oldState => ({ visibleMenu: !oldState.visibleMenu }));
  }

  handleVisableSubMenu() {
    this.setState(oldState => ({ visibleSubMenu: !oldState.visibleSubMenu }));
  }

  render() {
    const { visibleMenu, visibleSubMenu } = this.state;
    return (
      <div>
        <div className="header-top-bar-container clearfix">
          <div className="header-top-bar">
            <ul className="contact-details clearfix">
              <li className="template-phone">+48 793 700 098</li>
              <li className="template-mail">
                <a href="mailto:bmw.luk@op.pl">bmw.luk@op.pl</a>
              </li>
              <li className="template-clock">Pon - Pt: 9:00 - 17:00</li>
            </ul>
            <ul className="social-icons">
              <li>
                <a
                  target="_blank"
                  href="https://www.facebook.com/LUK-LUK-Auto-Serwis-Niezale%C5%BCny-Serwis-BMW-Racib%C3%B3rz-668943926599017/"
                  className="social-facebook"
                  title="facebook"
                />
              </li>
            </ul>
          </div>
          <a href="#" className="header-toggle template-arrow-up" />
        </div>
        <div className="header-container">
          {/* <div class="header-container sticky"> */}
          <div className="vertical-align-table column-1-1">
            <div className="header clearfix">
              <div style={{ position: 'relative' }} className="logo vertical-align-cell">
                <Link to="/">
                  <Logo logo={logoImg} />
                </Link>
              </div>
              <a onClick={this.handleVisableMenu} className="mobile-menu-switch vertical-align-cell">
                <span className="line" />
                <span className="line" />
                <span className="line" />
              </a>
              <div className="menu-container clearfix vertical-align-cell">
                <nav>
                  <ul className="sf-menu">
                    <li>
                      <Link exact to="/" activeStyle={activeLinkStyle}>
                        Główna
                      </Link>
                    </li>
                    <li>
                      <Link to="/o-nas" activeStyle={activeLinkStyle}>
                        O nas
                      </Link>
                    </li>
                    <li>
                      <Link to="/uslugi" activeStyle={activeLinkStyle}>
                        Oferta
                      </Link>
                      <ul>
                        <li>
                          <Link to="/uslugi/mechanika">Mechanika</Link>
                        </li>
                        <li>
                          <Link to="/uslugi/diagnostyka">Diagnostyka / Kodowanie / Doposażanie pojazdu</Link>
                        </li>
                        <li>
                          <Link to="/uslugi/naprawy-powypadkowe">Naprawy powypadkowe</Link>
                        </li>
                        <li>
                          <Link to="/uslugi/czesci-nowe-i-uzywane">Części nowe i potestowe oraz używane</Link>
                        </li>
                        <li>
                          <Link to="/uslugi/motocykle">Motocykle</Link>
                        </li>
                        <li>
                          <Link to="/uslugi/profesjonalny-serwis-ogumienia">Profesjonalny serwis ogumienia</Link>
                        </li>
                        <li>
                          <Link to="/uslugi/pomoc-drogowa">Pomoc drogowa</Link>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <Link to="/certyfikaty" activeStyle={activeLinkStyle}>
                        Certyfikaty
                      </Link>
                    </li>

                    <li>
                      <Link
                        to="/kontakt"
                        style={{
                          padding: '0',
                          height: '50px',
                          display: 'flex',
                          alignItems: 'center',
                          marginLeft: '20px',
                        }}
                        activeStyle={activeLinkStyle}
                      >
                        <button className="nav-cta">Skontaktuj się</button>
                      </Link>
                    </li>
                  </ul>
                </nav>
                <div className="mobile-menu-container">
                  <div className="mobile-menu-divider" />
                  <nav>
                    <ul
                      style={visibleMenu ? { display: 'block' } : null}
                      className="mobile-menu collapsible-mobile-submenus"
                    >
                      <li>
                        <Link to="/">Home</Link>
                      </li>
                      <li>
                        <Link to="/o-nas">O nas</Link>
                      </li>
                      <li>
                        <Link to="/uslugi">Oferta</Link>
                        <a href="#" className="template-arrow-menu" onClick={this.handleVisableSubMenu} />
                        <ul style={visibleSubMenu ? { display: 'block' } : null}>
                          <li>
                            <Link to="/uslugi/mechanika">Mechanika</Link>
                          </li>
                          <li>
                            <Link to="/uslugi/diagnostyka">Diagnostyka / Kodowanie / Doposażanie pojazdu</Link>
                          </li>
                          <li>
                            <Link to="/uslugi/naprawy-powypadkowe">Naprawy powypadkowe</Link>
                          </li>
                          <li>
                            <Link to="/uslugi/czesci-nowe-i-uzywane">Części nowe i potestowe oraz używane</Link>
                          </li>
                          <li>
                            <Link to="/uslugi/motocykle">Motocykle</Link>
                          </li>
                          <li>
                            <Link to="/uslugi/profesjonalny-serwis-ogumienia">Profesjonalny serwis ogumienia</Link>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <Link to="/certyfikaty">Certyfikaty</Link>
                      </li>
                      <li>
                        <Link to="/kontakt">Kontakt</Link>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js